import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class LogoutService {

    private baseUrl: string = '../logout';
    constructor (
        private http: Http
    ) {}

    save() {
        return this.http.post(`${this.baseUrl}`, null)
            .map((res:any) => res.json());
    }

}


// WEBPACK FOOTER //
// ./public/upgrade/core/logout.service.ts